import React from 'react';
import { Col } from '@thd-olt-component-react/core-ui';
import { CollectionsSuperSku } from '@thd-olt-component-react/super-sku';
import proptypes from 'prop-types';
const { arrayOf, shape, string, func } = proptypes;
import { convertStrHyphenLowercase } from '../../CollectionHelpers';

export const AvailableOptionsTabs = ({ availableOptions, channel, onChange, collectionName }) => {
  const matchingOption = availableOptions?.linkedCollections?.find(
    (value) => convertStrHyphenLowercase(value.id) === collectionName
  );

  return (
    <Col data-testid="vendor-collection-supersku" flatten>
      <CollectionsSuperSku
        attributes={availableOptions}
        channel={channel}
        collectionId={convertStrHyphenLowercase(matchingOption?.id || '')}
        onChange={onChange}
      />
    </Col>
  );
};

AvailableOptionsTabs.displayName = 'AvailableOptionsTabs';

AvailableOptionsTabs.propTypes = {
  collectionName: string.isRequired,
  availableOptions: shape({
    title: string,
    linkedCollections: arrayOf(shape({
      id: string,
      name: string
    }))
  }).isRequired,
  channel: string.isRequired,
  onChange: func.isRequired
};